import { createSlice } from '@reduxjs/toolkit';

export const applicationSlice = createSlice({
  name: 'application',
  initialState: {
    list: {},
    selected: null,
    individualList: {},
    nonIndividualList: {},
    existingFranchiseList: {},
    authorizedDriversList: {},
    requirementList: {},
    appointmentsList: {},
    reappointmentsList: {},
    paymentFeesList: {},
    paymentTransactionList: {},
    serviceUnitsList: {},
    serviceUnits: {},
  },
  reducers: {
    setList: (state, action) => {
      state.list = {
        ...state.list,
        ...action.payload
      }|| {}
    },
    setIndividualList: (state, action) => {
      state.individualList = {
        ...state.individualList,
        ...action.payload 
      } || {}
    },
    setNonIndividualList: (state, action) => {
      state.nonIndividualList = {
        ...state.nonIndividualList,
        ...action.payload 
      } || {}
    },
    setExistingFranchiseList: (state, action) => {
      state.existingFranchiseList = {
        ...state.existingFranchiseList,
        ...action.payload
      } || {}
    },
    setAuthorizedDriversList: (state, action) => {
      state.authorizedDriversList = {
        ...state.authorizedDriversList,
        ...action.payload 
      } || {}
    }, 
    setRequirementList: (state, action) => {
      state.requirementList = {
        ...state.requirementList,
        ...action.payload 
      } || {}
    }, 
    setAppointmentList: (state, action) => {
      state.appointmentsList = {
        ...state.appointmentsList,
        ...action.payload 
      } || {}
    }, 
    setReappointmentList: (state, action) => {
      state.reappointmentsList = {
        ...state.reappointmentsList,
        ...action.payload 
      } || {}
    }, 
    setPaymentFeesList: (state, action) => {
      state.paymentFeesList = {
        ...state.paymentFeesList,
        ...action.payload 
      } || {}
    },
    setPaymentTransactionList: (state, action) => {
      state.paymentTransactionList = {
        ...state.paymentTransactionList,
        ...action.payload 
      } || {}
    },
    createUpdateItem: (state, { payload }) => {
      
      state.list = {
        ...state.list,
        ...payload
      }
    },
    setSelected: (state, action) => {
      state.selected = +action.payload
    },
    removeItem: (state, action) => {
      delete state.list[action.payload]
      state.selected = +Object.keys(state.list)[0]
    },
    setServiceUnitsList: (state, action) => {
      state.serviceUnitsList = {
        ...state.serviceUnitsList,
        ...action.payload 
      } || {}
    }, 
    setServiceUnits: (state, action) => {
      state.serviceUnits = {
        ...state.serviceUnits,
        ...action.payload 
      } || {}
    }, 
  }
})


export const { setList,  createUpdateItem, setSelected, removeItem,
  setIndividualList, setNonIndividualList, setExistingFranchiseList, setAuthorizedDriversList, setRequirementList, setAppointmentList, setReappointmentList,
  setPaymentFeesList, setPaymentTransactionList, setServiceUnitsList, setServiceUnits  } = applicationSlice.actions;

export default applicationSlice.reducer;